import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const GeneralSettings = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */
    const [settings, setSettings] = useState({
        email: "",
        phone: "",
        address: "",
        map_url: "",
        footer_about_us: "",
        facebook_url: "",
        instagram_url: "",
        twitter_url: "",
        youtube_url: "",
        linkedin_url: ""
    });

    const [timings, setTimings] = useState([
        { day_label: "", time_label: "" }
    ]);

    const [pageBanner, setPageBanner] = useState(null);
    const [pageBannerPreview, setPageBannerPreview] = useState("");

    {/* ------------ For Video Section --------------- */}

    const [videoFile, setVideoFile] = useState(null);
    const [videoPreview, setVideoPreview] = useState("");


    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/general_settings/get_general_settings/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { settings, timings } = res.data.data;

                setSettings({
                    email: settings?.email || "",
                    phone: settings?.phone || "",
                    address: settings?.address || "",
                    map_url: settings?.map_url || "",
                    footer_about_us: settings?.footer_about_us || "",
                    facebook_url: settings?.facebook_url || "",
                    instagram_url: settings?.instagram_url || "",
                    twitter_url: settings?.twitter_url || "",
                    youtube_url: settings?.youtube_url || "",
                    linkedin_url: settings?.linkedin_url || ""
                });

                setTimings(
                    timings.length
                        ? timings
                        : [{ day_label: "", time_label: "" }]
                );

                if (settings?.page_banner) {
                    setPageBannerPreview(
                        `${baseAPIUrl}assets/images/settings/${settings.page_banner}`
                    );
                }

                if (settings?.school_video) {
                    setVideoPreview(
                        `${baseAPIUrl}assets/images/settings/${settings.school_video}`
                    );
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- INPUT HANDLERS ---------------- */
    const handleSettingsChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    };

    const handleTimingChange = (index, field, value) => {
        setTimings(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [field]: value,
            };
            return updated;
        });
    };

    const addTiming = () => {
            setTimings(prev => [...prev, { day_label: "", time_label: "" }]);
    };

    const deleteTiming = (index) => {
        setTimings(prev => {
            if (prev.length <= 1) return prev;
            return prev.filter((_, i) => i !== index);
        })
    };


    /* ---------------- SUBMIT ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("settings", JSON.stringify(settings));
            formData.append("timings", JSON.stringify(timings));

            if (pageBanner) {
                formData.append("page_banner", pageBanner);
            }

            if (videoFile) {
                formData.append("school_video", videoFile);
            }

            const res = await axios.post(
                `${baseAPIUrl}admin/general_settings/add_edit_general_settings`,
                formData,
                { withCredentials: true }
            );
            fetchSettings();
            scrollToTop();
            setMessage(res.data.msg);
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">
                                General settings
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    General settings
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h4>Edit General settings</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                {message && (
                                    <p className="text-center text-danger">{message}</p>
                                )}

                                {/* Section Fields */}
                                {/* EMAIL */}
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Email"
                                        value={settings.email}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* PHONE */}
                                <div className="form-group">
                                    <label>Phone Number</label>
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Phone number"
                                        value={settings.phone}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* ADDRESS */}
                                <div className="form-group">
                                    <label>Address</label>
                                    <textarea
                                        name="address"
                                        rows="3"
                                        className="form-control"
                                        value={settings.address}
                                        placeholder="Address"
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* GOOGLE MAP */}
                                <div className="form-group">
                                    <label>Google Map URL</label>
                                    <textarea
                                        name="map_url"
                                        rows="6"
                                        className="form-control"
                                        value={settings.map_url}
                                        placeholder="Map URL"
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* Footer about us */}
                                <div className="form-group">
                                    <label>Footer about us</label>
                                    <textarea
                                        name="footer_about_us"
                                        rows="6"
                                        className="form-control"
                                        value={settings.footer_about_us}
                                        placeholder="Footer about us"
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* Facebook */}
                                <div className="form-group">
                                    <label>Facebook URL</label>
                                    <input
                                        type="text"
                                        name="facebook_url"
                                        className="form-control"
                                        placeholder="Facebook URL"
                                        value={settings.facebook_url}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* Instagram */}
                                <div className="form-group">
                                    <label>Instagram URL</label>
                                    <input
                                        type="text"
                                        name="instagram_url"
                                        className="form-control"
                                        placeholder="Instagram URL"
                                        value={settings.instagram_url}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* Twitter */}
                                <div className="form-group">
                                    <label>X handle URL</label>
                                    <input
                                        type="text"
                                        name="twitter_url"
                                        className="form-control"
                                        placeholder="X handle URL"
                                        value={settings.twitter_url}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* Youtube */}
                                <div className="form-group">
                                    <label>Youtube handle URL</label>
                                    <input
                                        type="text"
                                        name="youtube_url"
                                        className="form-control"
                                        placeholder="Youtube handle URL"
                                        value={settings.youtube_url}
                                        onChange={handleSettingsChange}
                                    />
                                </div>

                                {/* LinkidIn */}
                                <div className="form-group">
                                    <label>LinkedIn handle URL</label>
                                    <input
                                        type="text"
                                        name="linkedin_url"
                                        className="form-control"
                                        placeholder="Linked In handle URL"
                                        value={settings.linkedin_url}
                                        onChange={handleSettingsChange}
                                    />
                                </div>
                                
                                {/* Office Timings UI */}
                                <div className="form-group">
                                    <label>Office Timings</label>
                                    {timings.map((row, i) => (
                                        <div key={i} className="d-flex gap-2 mb-2">
                                            <input
                                                className="form-control"
                                                placeholder="Day (e.g. Mon–Fri)"
                                                value={row.day_label}
                                                onChange={(e) =>
                                                    handleTimingChange(i, "day_label", e.target.value)
                                                }
                                            />
                                            <input
                                                className="form-control"
                                                placeholder="Time (e.g. 9:00 AM – 4:00 PM)"
                                                value={row.time_label}
                                                onChange={(e) =>
                                                    handleTimingChange(i, "time_label", e.target.value)
                                                }
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => deleteTiming(i)} 
                                                disabled={timings.length <= 1}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    ))}

                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={addTiming}
                                    >
                                        + Add More
                                    </button>


                                    {/* Image Upload */}
                                    <div className="form-group mt-3">
                                        <label>School inner page banner</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setPageBanner(file);
                                                    setPageBannerPreview(URL.createObjectURL(file));
                                                }
                                            }}
                                        />
                                        {pageBannerPreview && (
                                            <img
                                                src={pageBannerPreview}
                                                alt="Page Banner Preview"
                                                style={{ maxWidth: "120px", marginTop: "10px" }}
                                            />
                                        )}
                                    </div>
                                    
                                    {/* Video Upload */}
                                    <div className="form-group">
                                        <label>Upload School Video (MP4)</label>
                                        <input
                                            type="file"
                                            accept="video/mp4"
                                            className="form-control"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setVideoFile(file);
                                                    setVideoPreview(URL.createObjectURL(file));
                                                }
                                            }}
                                        />

                                        {videoPreview && (
                                            <video width="200" controls className="mt-2">
                                                <source src={videoPreview} type="video/mp4" />
                                            </video>
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GeneralSettings;
